var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("custom-btn-icon", {
    attrs: {
      "btn-text": _vm.paused ? "Reprendre" : "Prendre",
      loading: _vm.loading,
      disabled: _vm.loading,
      color: "primary",
      icon: "mdi-account-lock"
    },
    on: { click: _vm.onClick }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }